import { createIntl, createIntlCache } from 'react-intl';

import { APIConfig } from 'src/config';
import { DEFAULT_LOCALE, getDefaultLocale, i18nMessagesForLocale } from 'src/util/i18n/handler';

// Partner locale is the configured locale for public/config.js.
const partnerLocale = APIConfig()?.LOCALE || DEFAULT_LOCALE;

// Prevents memory leak per recommendation by react-intl.
const cache = createIntlCache();

// Load the locale messages.
const messages = {
  ...i18nMessagesForLocale(getDefaultLocale(partnerLocale)),
  ...i18nMessagesForLocale(partnerLocale),
};

const intl = createIntl(
  {
    locale: partnerLocale,
    messages,
  },
  cache,
);

/**
 * Returns the configured partner currency symbol from its currency formatter.
 * @param {import('react-intl').IntlShape} intlCurrency - Partner currency formatter.
 * @returns {string|null} Partner currency symbol, or null when no formatter is available.
 */
export const getCurrencySymbol = (intlCurrency) => {
  if (!intlCurrency) {
    return null;
  }

  return intlCurrency.formatMessage({
    id: 'common.entities.currency.label',
    defaultMessage: '$',
  });
};

export const useIntlCurrency = () => intl;
